import * as Yup from 'yup';
import { rulesAndAlertsFormModel } from './rulesAndAlertsFormModel';

const {
  formField: {
    name,
    description,
    status
  }
} = rulesAndAlertsFormModel;

export default Yup.object().shape({
  [name.name]: Yup.string()
    .max(255, 'Máximo 255 caracteres')
    .required(`${name.requiredErrorMsg}`),
  [description.name]: Yup.string().nullable(),
  [status.name]: Yup.boolean()
});
